import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface MachineListState {
    list: any,
  }
  
const initialState:MachineListState = {
    list: undefined,
}

export const machinelistSlice = createSlice({
    name:"machineList",
    initialState,
    reducers:{
        UpdateMachineList: (state,action) => {
            state.list = action.payload.machineList;
        },
        AddMachine: (state,action) => {
            state.list = undefined;
        },
        EditMachine: (state,action) => {
            state.list = undefined;
        },
        RemoveMachine: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdateMachineList,AddMachine,EditMachine,RemoveMachine} = machinelistSlice.actions

export const selectmachineList = (state: RootState) => state.machineList

export default machinelistSlice.reducer;